// /travel/plans/:id — a plan Yasmin made, on the web. Same data as the app's Trips › Planned with Yasmin.
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { usePageMeta } from "@/lib/site";
import { yasminApi } from "@/lib/yasminApi";
import { Itinerary } from "@/pages/yasmin/YasminChat";

export default function YasminPlan() {
  const { id } = useParams();
  const [plan, setPlan] = useState(undefined);
  useEffect(() => { yasminApi.plan(id).then(setPlan).catch(() => setPlan(null)); }, [id]);
  usePageMeta(plan?.title ? plan.title + " · Yasmin plan" : "Yasmin plan", "A trip plan made with Yasmin on Fable +.");
  const save = async (pid) => {
    try { const p = await yasminApi.save(pid); setPlan((x) => ({ ...x, ...p, saved: true })); toast.success("Plan saved."); }
    catch (e) { toast.error(e.message || "Couldn't save the plan."); }
  };
  return (
    <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6" data-testid="yasmin-plan-page">
      <Link to="/travel/trips" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"><ArrowLeft size={14} /> My trips</Link>
      {plan === undefined ? (
        <div className="mt-6 space-y-3">{[0, 1, 2].map((i) => <Skeleton key={i} className="h-20 rounded-2xl" />)}</div>
      ) : plan === null ? (
        <div className="mt-8 rounded-2xl border border-dashed p-8 text-center" data-testid="yasmin-plan-missing">
          <p className="font-semibold">We couldn't find that plan</p>
          <p className="mt-1 text-sm text-muted-foreground">It may have been removed. Ask Yasmin for a new one.</p>
          <Link to="/yasmin/chat"><Button className="mt-4 rounded-full"><Sparkles size={16} className="mr-2" />Ask Yasmin</Button></Link>
        </div>
      ) : (
        <>
          <h1 className="mt-4 font-serif-display text-3xl font-bold">{plan.title}</h1>
          <p className="mt-1 text-sm text-muted-foreground">{plan.travellers ? plan.travellers + " traveller" + (plan.travellers === 1 ? "" : "s") + " · " : ""}Prices and times come from Fable + and our travel partners. Nothing is booked until you confirm.</p>
          <div className="mt-6 rounded-3xl border bg-card p-4 sm:p-6"><Itinerary plan={plan} onSave={save} /></div>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to={"/yasmin/chat?q=" + encodeURIComponent("Change my plan “" + plan.title + "”: ")}><Button className="rounded-full" data-testid="yasmin-plan-change"><Sparkles size={16} className="mr-2" />Change it with Yasmin</Button></Link>
            <Link to="/travel/plan"><Button variant="outline" className="rounded-full">Plan a trip yourself</Button></Link>
          </div>
        </>
      )}
    </div>
  );
}
